module.exports = __webpack_public_path__ + "static/media/garage-vehicle-placeholder.5a62adc6.svg";